import type {AnalyticsEvent} from "@khanacademy/event-schemas";

import type {ConversionName, PartialLearningTimeInfo} from "../types.ts";

import {markConversion} from "./mark-conversion.ts";

export function publishAnalyticsEvent(
    event: AnalyticsEvent,
    learningTimeInfo: PartialLearningTimeInfo,
    legacyConversionName?: ConversionName,
): Promise<Response | void> {
    return markConversion(
        {
            id: legacyConversionName || "cedar_event",
            event,
        },
        learningTimeInfo,
    );
}
